// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
import "whatwg-fetch";
import Vue from "vue";
import VueI18n from "vue-i18n";
import App from "./App";
import Es6Promise from "es6-promise";
Es6Promise.polyfill();
import store from "./plugins/vuex";
import router from "./plugins/router";
import firebase from "firebase/app";
import VueMaterial from "vue-material";
import "vue-material/dist/vue-material.min.css";
import "vue-material/dist/theme/default.css";
import jquery from "jquery";
import axios from "axios";
import Notifications from "vue-notification";
import VueMoment from "vue-moment";
import moment from "moment";
import "./assets/styles/material.scss";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import parse from "date-fns/parse";
import format from "date-fns/format";
import { messages } from "./utils/messages";
import { envConfig } from "./config/config";

Vue.use(VueI18n);
Vue.use(Vuetify);
Vue.use(VueMaterial);
Vue.use(Notifications);
Vue.use(require("vue-moment"));

Vue.config.productionTip = false;

let app = "";

firebase.initializeApp(envConfig.FIREBASE_CONFIG);

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    const i18n = new VueI18n({
      locale: "it",
      messages
    });
    /* eslint-disable no-new */
    app = new Vue({
      i18n,
      router,
      store,
      render: h => h(App)
    }).$mount("#app");
  }
});



// WEBPACK FOOTER //
// ./src/main.js